module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAbFBMVEUAAABicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZk5oNo3AAAAI3RSTlMAgLTxDvzcWEv3rYp3a1FDOurTxrGYcREH4mUyvbampV8oGru8+f8AAACnSURBVCjPrclXDsMgFETRiQnFDXBv6W//e4xlUGzIX5T7NaODX7KCwlLpQLDkWJsI5oAyhPXkIYFvBGCyoYihFwaW0xiAthgmqqTgBqcDzNSsP68oNdihxYNSVk4NbKtwgDt4rRjR4v4OGfQLGXWI4Yo1XT+/4Iaw0gOvT2EXDxXFeSjYVkpE3M0OrvNWt0LjJoKWPM814mRRSqWULPt5DIDRpwH/7g2+FxDeCvOpRwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_monitor.png
// module id = 99L2
// module chunks = 9